module.exports = __webpack_public_path__ + "static/跨国公司研发中心证书-95e887134b8852f6b4d7fdc5cbd73614.jpg";